import { Pipe , PipeTransform } from '@angular/core'

@Pipe({
		name: 'notfountReason'
})
export class TreeNotFoundReasonPipe implements PipeTransform {
		public transform(value: 'ADDRESS_INVALID' | 'TREE_REMOVED' | 'RESIDENT_NOT_HOME' | 'EVIDENCE_ENVIROMENTAL_CRIME'): string {
				if (value === 'ADDRESS_INVALID') {
						return 'Endereço inválido'
				} else if (value === 'TREE_REMOVED') {
						return 'Árvore removida'
				} else if (value === 'RESIDENT_NOT_HOME') {
						return 'Requerente ausente'
				} else if (value === 'EVIDENCE_ENVIROMENTAL_CRIME') {
						return 'Fiscalização por crime ambiental'
				} else if (value === 'OTHER') {
						return 'Outro'
				}
		}
}
